export default "__VITE_ASSET__C0I5Sn25__"